export const createQuery = (apiKey, text, params = {}) => {
    const q = {
        api_key: apiKey,
        text,
        lang: params.lang,
        size: params.size?.toString(),
        sources: params.sources?.map(l => l.trim()).join(','),
        layers: params.layers?.map(l => l.trim()).join(','),
        'focus.point.lat': params.focusPoint?.lat?.toString(),
        'focus.point.lon': params.focusPoint?.lon?.toString(),
        'boundary.country': params.boundary?.country,
        'boundary.gid': params.boundary?.gid,
        'boundary.circle.lat': params.boundary?.circle?.lat?.toString(),
        'boundary.circle.lon': params.boundary?.circle?.lon?.toString(),
        'boundary.circle.radius': params.boundary?.circle?.lon?.toString(),
        'boundary.rect.min_lat': params.boundary?.rect?.minLat?.toString(),
        'boundary.rect.max_lat': params.boundary?.rect?.maxLon?.toString(),
        'boundary.rect.min_lon': params.boundary?.rect?.minLon?.toString(),
        'boundary.rect.max_lon': params.boundary?.rect?.maxLon?.toString()
    };
    // don’t return empty values (null, undefined, '') as to not have ?size=undefined or empty values in the actual URL query
    return Object.fromEntries(Object.entries(q).filter(([_, v]) => v != null && v !== ''));
};
